// components/ConditionalSiteHeader.tsx — NEW FILE at components/ConditionalSiteHeader.tsx
// Renders the global SiteHeader on all pages EXCEPT /dashboard,
// since the dashboard has its own dedicated header (DashboardHeader.tsx)

"use client";

import { usePathname } from "next/navigation";
import { SiteHeader } from "@/components/SiteHeader";

export function ConditionalSiteHeader() {
  const pathname = usePathname();
  const isDashboard = pathname.startsWith("/dashboard");

  if (isDashboard) return null;

  return <SiteHeader />;
}
